export default {
  readMore: 'Čítať viac',
  fullText: 'Celý text',
};
